const OLARK_LOADER_ID = "olark-loader";
const OLARK_HIDE_STYLE_ID = "olark-launcher-hide";
const DEFAULT_OLARK_ID = "7380-006-12-2661";

let olarkReadyPromise = null;

const OLARK_NATIVE_LAUNCHER_HIDE_CSS = `
	#olark-wrapper .olark-launch-button,
	.olark-launch-button,
	#olark-container .olark-branding-button,
	#habla_beta_container_do_not_rely_on_div_classes_or_names .olark-branding-link {
		display: none !important;
		visibility: hidden !important;
		opacity: 0 !important;
		pointer-events: none !important;
	}
`;

export const isOlarkSupport = () => window.PREFER_SUPPORT === "OLARK";

export const getOlarkId = () => window.OLARK_ID || DEFAULT_OLARK_ID;

export const hideOlarkNativeLauncher = () => {
	if (document.getElementById(OLARK_HIDE_STYLE_ID)) return;
	const el = Object.assign(document.createElement("style"), {
		id: OLARK_HIDE_STYLE_ID,
		innerHTML: OLARK_NATIVE_LAUNCHER_HIDE_CSS,
	});
	document.head.appendChild(el);
};

const whenOlarkReady = () =>
	new Promise((resolve) => {
		if (!window.olark) {
			resolve();
			return;
		}

		let settled = false;
		const finish = () => {
			if (settled) return;
			settled = true;
			resolve();
		};

		window.olark("api.chat.onReady", finish);
		setTimeout(finish, 3000);
	});

const keepOlarkChatCollapsed = () => {
	if (!window.olark) return;
	window.olark("api.box.shrink");
};

const configureOlark = async () => {
	if (!window.olark) return;
	hideOlarkNativeLauncher();
	window.olark("api.chat.onReady", () => {
		hideOlarkNativeLauncher();
		keepOlarkChatCollapsed();
	});
	await whenOlarkReady();
	hideOlarkNativeLauncher();
	keepOlarkChatCollapsed();
};

const injectOlarkScript = () =>
	new Promise((resolve) => {
		if (document.getElementById(OLARK_LOADER_ID)) {
			const check = () => {
				if (olarkReadyPromise) {
					olarkReadyPromise.then(resolve);
					return;
				}
				setTimeout(check, 100);
			};
			check();
			return;
		}

		hideOlarkNativeLauncher();

		(function (o, l, a, r, k, y) {
			if (o.olark) return;
			r = "script";
			y = l.createElement(r);
			r = l.getElementsByTagName(r)[0];
			y.async = 1;
			y.id = OLARK_LOADER_ID;
			y.src = `//${a}`;
			y.onload = () => {
				olarkReadyPromise = configureOlark();
				olarkReadyPromise.then(resolve);
			};
			r.parentNode.insertBefore(y, r);
			y = o.olark = function () {
				k.s.push(arguments);
				k.t.push(+new Date());
			};
			y.extend = function (i, j) {
				y("extend", i, j);
			};
			y.identify = function (i) {
				y("identify", (k.i = i));
			};
			y.configure = function (i, j) {
				y("configure", i, j);
				k.c[i] = j;
			};
			k = y._ = { s: [], t: [+new Date()], c: {}, l: a };
		})(window, document, "static.olark.com/jsclient/loader.js");

		window.olark.identify(getOlarkId());
	});

export const loadOlark = () => {
	if (olarkReadyPromise) return olarkReadyPromise;
	return injectOlarkScript();
};

export const openOlark = async () => {
	await loadOlark();

	const expand = () => {
		if (!window.olark) return false;
		hideOlarkNativeLauncher();
		window.olark("api.box.show");
		window.olark("api.box.expand");
		return true;
	};

	if (!expand()) {
		setTimeout(expand, 400);
		setTimeout(expand, 1200);
	}
};

export const hideOlarkLauncher = () => {
	if (!window.olark) return;
	window.olark("api.box.hide");
	hideOlarkNativeLauncher();
};

export const closeOlarkBox = keepOlarkChatCollapsed;

export const openLiveSupport = () => {
	if (window.PREFER_SUPPORT === "INTERCOM") {
		window.Intercom?.("show");
		return;
	}

	if (isOlarkSupport()) {
		void openOlark();
		return;
	}

	if (window.ZENDESK_API_VERSION === 1) {
		window?.zE?.activate?.();
		return;
	}

	if (window.ZENDESK_API_VERSION === 2) {
		window?.zE?.("messenger", "open");
	}
};
